import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, ListHeader, ActionsTableHeader, Tabs, Tab, OverdueCreditsTab, Paper, Button, Row, Col, Form, Input, Dropdown, DateTimePicker, showSuccess, useWindowSize } from 'components';
import { showApiError } from 'utils';
import { getAllActions, getAllCreditsDropdown, createAction, completeAction, snoozeAction } from 'services';
import { actionSearchTypesNameSelect } from 'enums';
import { tableWrap } from 'styles';
import { actionsListColumns, actionCardRenderer } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";
var CARD_BREAKPOINT = 1200;
var addButtonWrap = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '1em'
};

var snoozeBarStyle = function snoozeBarStyle(theme) {
  return {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '1.2em',
    padding: '1.2em 2em',
    marginBottom: '1em',
    backgroundColor: theme.warningLight,
    border: "1px solid ".concat(theme.warning),
    '& .snooze-icon': {
      fontSize: '2rem',
      color: theme.warning,
      flexShrink: 0,
      marginBottom: '0.4em'
    },
    '& .snooze-picker': {
      flex: '0 0 200px',
      '& > div': {
        marginBottom: 0
      }
    },
    '& .snooze-actions': {
      display: 'flex',
      gap: '0.6em',
      flexShrink: 0,
      paddingBottom: '1px'
    }
  };
};

var ActionsTab = function ActionsTab() {
  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var tableRef = useRef();
  var isMobile = windowWidth < CARD_BREAKPOINT;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showForm = _useState2[0],
      setShowForm = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      creditOptions = _useState4[0],
      setCreditOptions = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      snoozeActionId = _useState6[0],
      setSnoozeActionId = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      snoozeDate = _useState8[0],
      setSnoozeDate = _useState8[1];

  useEffect(function () {
    if (showForm && !creditOptions.length) fetchCredits();
  }, [showForm]);

  var fetchCredits = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllCreditsD, _yield$getAllCreditsD2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllCreditsDropdown();

            case 2:
              _yield$getAllCreditsD = _context.sent;
              _yield$getAllCreditsD2 = _slicedToArray(_yield$getAllCreditsD, 2);
              res = _yield$getAllCreditsD2[0];
              err = _yield$getAllCreditsD2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setCreditOptions((res || []).map(function (c) {
                return {
                  label: "".concat(c.number, " / ").concat(c.date),
                  value: c.id
                };
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCredits() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchAllActions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tableOptions) {
      var _yield$getAllActions, _yield$getAllActions2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAllActions(tableOptions);

            case 2:
              _yield$getAllActions = _context2.sent;
              _yield$getAllActions2 = _slicedToArray(_yield$getAllActions, 2);
              res = _yield$getAllActions2[0];
              err = _yield$getAllActions2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", [null, err]);

            case 9:
              return _context2.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchAllActions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleComplete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(actionId) {
      var _tableRef$current;

      var _yield$completeAction, _yield$completeAction2, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return completeAction(actionId);

            case 2:
              _yield$completeAction = _context3.sent;
              _yield$completeAction2 = _slicedToArray(_yield$completeAction, 2);
              err = _yield$completeAction2[1];

              if (!err) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Действието е маркирано като завършено.');
              (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData();

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleComplete(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSnoozeOpen = function handleSnoozeOpen(actionId) {
    setSnoozeActionId(actionId);
    setSnoozeDate(null);
  };

  var handleSnoozeConfirm = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _tableRef$current2;

      var formatted, _yield$snoozeAction, _yield$snoozeAction2, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (snoozeDate) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              formatted = moment.isMoment(snoozeDate) ? snoozeDate.format('YYYY-MM-DD') : snoozeDate;
              _context4.next = 5;
              return snoozeAction(snoozeActionId, formatted);

            case 5:
              _yield$snoozeAction = _context4.sent;
              _yield$snoozeAction2 = _slicedToArray(_yield$snoozeAction, 2);
              err = _yield$snoozeAction2[1];

              if (!err) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 10:
              showSuccess('Действието е отложено.');
              setSnoozeActionId(null);
              setSnoozeDate(null);
              (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.getData();

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSnoozeConfirm() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSnoozeCancel = function handleSnoozeCancel() {
    setSnoozeActionId(null);
    setSnoozeDate(null);
  };

  var callbacks = {
    onComplete: handleComplete,
    onSnooze: handleSnoozeOpen
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5) {
      var _tableRef$current3;

      var values, _yield$createAction, _yield$createAction2, err;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              values = _ref5.values;
              _context5.next = 3;
              return createAction({
                credit_id: values.credit_id,
                action: values.action,
                note: values.note,
                follow_up_date: values.follow_up_date
              });

            case 3:
              _yield$createAction = _context5.sent;
              _yield$createAction2 = _slicedToArray(_yield$createAction, 2);
              err = _yield$createAction2[1];

              if (!err) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("return", showApiError(err));

            case 8:
              showSuccess('Действието е създадено успешно.');
              setShowForm(false);
              (_tableRef$current3 = tableRef.current) === null || _tableRef$current3 === void 0 ? void 0 : _tableRef$current3.getData();

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleSubmit(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    style: addButtonWrap
  }, ___EmotionJSX(Button, {
    small: true,
    onClick: function onClick() {
      return setShowForm(function (prev) {
        return !prev;
      });
    },
    leftIcon: {
      iconName: showForm ? 'la la-times' : 'la la-plus',
      size: 18
    }
  }, showForm ? 'Затвори' : 'Добави действие')), showForm && ___EmotionJSX(Paper, {
    header: "\u041D\u043E\u0432\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
    margin: "0 0 1.5em 0"
  }, ___EmotionJSX(Form, {
    onSubmit: handleSubmit
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    md: 4
  }, ___EmotionJSX(Dropdown, {
    noClear: true,
    required: true,
    formId: "credit_id",
    label: "\u041A\u0440\u0435\u0434\u0438\u0442",
    placeholder: "\u0418\u0437\u0431\u0435\u0440\u0438 \u043A\u0440\u0435\u0434\u0438\u0442...",
    options: creditOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    },
    searchable: true
  })), ___EmotionJSX(Col, {
    md: 3
  }, ___EmotionJSX(Dropdown, {
    noClear: true,
    required: true,
    formId: "action",
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
    options: actionSearchTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    md: 3
  }, ___EmotionJSX(DateTimePicker, {
    formId: "follow_up_date",
    label: "\u0414\u0430\u0442\u0430 \u0437\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u044F\u0432\u0430\u043D\u0435",
    required: true,
    timeFormat: false,
    dateFormat: "YYYY-MM-DD"
  })), ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX(Input, {
    formId: "note",
    type: "textarea",
    label: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
    required: true
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: true,
    justify: "flex-end"
  }, function (_ref7) {
    var onSubmit = _ref7.onSubmit;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return setShowForm(false);
      },
      margin: "0 1em 0 0"
    }, "\u041E\u0442\u043A\u0430\u0437"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438"));
  })))), snoozeActionId && ___EmotionJSX("div", {
    css: snoozeBarStyle
  }, ___EmotionJSX("i", {
    className: "las la-clock snooze-icon"
  }), ___EmotionJSX("div", {
    className: "snooze-picker"
  }, ___EmotionJSX(DateTimePicker, {
    small: true,
    label: "\u041E\u0442\u043B\u043E\u0436\u0438 \u0434\u043E",
    value: snoozeDate,
    onChange: setSnoozeDate,
    timeFormat: false,
    dateFormat: "YYYY-MM-DD"
  })), ___EmotionJSX("div", {
    className: "snooze-actions"
  }, ___EmotionJSX(Button, {
    small: true,
    color: "white",
    backColor: "#D97706",
    hoverBackColor: "#B45309",
    onClick: handleSnoozeConfirm
  }, "\u041E\u0442\u043B\u043E\u0436\u0438"), ___EmotionJSX(Button, {
    small: true,
    type: "secondary",
    onClick: handleSnoozeCancel
  }, "\u041E\u0442\u043A\u0430\u0437"))), ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchAllActions,
    columns: isMobile ? [] : actionsListColumns(callbacks),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: ActionsTableHeader,
    pageSize: 20,
    renderRow: isMobile ? actionCardRenderer(callbacks) : undefined
  })));
};

var OverdueTab = function OverdueTab() {
  return ___EmotionJSX(Paper, {
    margin: "1em 0"
  }, ___EmotionJSX(OverdueCreditsTab, null));
};

var ActionList = function ActionList(_ref8) {
  var _match$url;

  var match = _ref8.match;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  }), ___EmotionJSX(Tabs, {
    startingRoute: (_match$url = match === null || match === void 0 ? void 0 : match.url) !== null && _match$url !== void 0 ? _match$url : '/actions',
    noAnimation: true,
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/list",
    component: ActionsTab,
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  }), ___EmotionJSX(Tab, {
    url: "/overdue",
    component: OverdueTab,
    label: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438"
  })));
};

ActionList.propTypes = {
  match: PropTypes.object
};
export default ActionList;